import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home.vue';
import OwnershipChanges from '@/components/OwnershipChanges.vue';
import ProfileGrids from '@/components/ProfileGrids.vue';
import MyGrids from '@/components/MyGrids.vue';
import AllGrids from '@/components/AllGrids.vue';
import MyHangar from '@/components/MyHangar.vue';
import GridDetail from '@/components/GridDetail.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/ownership-changes',
      name: 'OwnershipChanges',
      component: OwnershipChanges,
    },
    {
      path: '/profile',
      name: 'ProfileGrids',
      component: ProfileGrids,
    },
    {
      path: '/mygrids',
      name: 'MyGrids',
      component: MyGrids,
    },
    {
      path: '/mygrids/:ownerid/:gridname',
      name: 'MyGridsWithDetails',
      component: MyGrids,
      props: true,
    },
    {
      path: '/allgrids',
      name: 'AllGrids',
      component: AllGrids,
    },
    {
      path: '/allgrids/:ownerid/:gridname',
      name: 'AllGridsWithDetails',
      component: AllGrids,
      props: true,
    },
    {
      path: '/myhangar',
      name: 'MyHangar',
      component: MyHangar,
    },
  ],
});
